import { isEmpty, clone, isEqual } from 'lodash';
import Dropdown from 'react-select';
import MediaQuery from 'react-responsive';
import PropTypes from 'prop-types';
import React from 'react';

import { MEDIA_QUERIES } from '@sm360/widget-commons-general';
import MobileInputDropDownMultiple from 'commons-forms/components/InputDropDown/MobileInputDropDownMultiple.jsx';
import 'react-select/dist/react-select.css';
import 'commons-forms/components/InputDropDown/InputDropDown.scss';

class InputDropdownMultiple extends React.Component {
    constructor(props) {
        super(props);

        this.getDropdownValue = this.getDropdownValue.bind(this);
        this.onChange = this.onChange.bind(this);
    }

    shouldComponentUpdate(newProps) {
        return !isEqual(this.props.defaultValues, newProps.values) || !isEqual(this.props.options, newProps.options);
    }

    onChange(selectedOptions) {
        // We need to do .filter(Boolean) to filter out the first element "undefined" since multiple select on Safari iOS handles the first interaction in a non conventional way...
        this.props.valueChange(selectedOptions.filter(Boolean), this.props.name);
    }

    getDropdownValue() {
        if (this.props.defaultValues) {
            return this.props.defaultValues.map((value) => value.value).join(',');
        }
        return null;
    }

    render() {
        const dropdownClassNames = clone(this.props.classNames);
        dropdownClassNames.push('styled-placeholder');
        dropdownClassNames.push('dropdown');

        if (!isEmpty(this.props.defaultValues)) {
            dropdownClassNames.push('not-empty');
        }

        return (
            <div className={dropdownClassNames.join(' ')}>
                <MediaQuery minWidth={MEDIA_QUERIES.TABLET.MIN}>
                    <label className="input-label" htmlFor={this.props.name}>
                        {this.props.placeholder}
                    </label>
                    <Dropdown
                        name={this.props.name}
                        value={this.getDropdownValue()}
                        placeholder={this.props.label || ''}
                        options={clone(this.props.options)}
                        onChange={this.onChange}
                        multi
                        clearable={false}
                    />
                </MediaQuery>

                <MediaQuery maxWidth={MEDIA_QUERIES.MOBILE.MAX}>
                    <MobileInputDropDownMultiple
                        options={this.props.options}
                        onChange={this.onChange}
                        defaultSelectionPlaceholder={this.props.placeholder}
                        classNames={['Select-control']}
                        name="bodyStylesFilter"
                    />
                    <span className="Select-arrow-zone">
                        <span className="Select-arrow" />
                    </span>
                </MediaQuery>
            </div>
        );
    }
}

InputDropdownMultiple.defaultProps = {
    classNames: [],
    label: '',
    placeholder: '',
};

InputDropdownMultiple.propTypes = {
    classNames: PropTypes.arrayOf(PropTypes.string),
    name: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            selected: PropTypes.bool.isRequired,
            value: PropTypes.number.isRequired,
        })
    ).isRequired,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    valueChange: PropTypes.func.isRequired,
    defaultValues: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            value: PropTypes.number.isRequired,
        })
    ).isRequired,
};

InputDropdownMultiple.displayName = 'InputDropdownMultiple';

export default InputDropdownMultiple;
